import {
    GET_TERMS_PAGE_SUCCEEDED,
    GET_CONFIDENTIALITY_PAGE_SUCCEEDED
} from "../actions/types";

const initalState = {
    terms: [],
    confidentiality: []
};

export default function(state = initalState, action){
    switch(action.type){
        case GET_TERMS_PAGE_SUCCEEDED:
            return {
                ...state,
                terms: action.payload
            };
        case GET_CONFIDENTIALITY_PAGE_SUCCEEDED:
            return {
                ...state,
                confidentiality: action.payload
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/SHARED/reducers/pages.reducer.js